import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from 'styled-components';
import { formatDate } from '../utils/time';
import SvgIcon from './SvgIcon';
const formatDateDiff = (diffSecs) => {
    const hours = Math.floor(diffSecs / 3600);
    const minutes = Math.floor((diffSecs % 3600) / 60);
    if (hours > 0) {
        return `${hours} hours`;
    }
    return `${minutes} minutes`;
};
export function ViewerPreLive({ scheduledStartTimestampMs, roundedCorners = true, }) {
    const liveIn = useMemo(() => {
        if (!scheduledStartTimestampMs) {
            return null;
        }
        const diff = scheduledStartTimestampMs - Date.now();
        return formatDateDiff(diff / 1000);
    }, [scheduledStartTimestampMs]);
    const startDate = useMemo(() => {
        if (!scheduledStartTimestampMs) {
            return null;
        }
        return new Date(scheduledStartTimestampMs);
    }, [scheduledStartTimestampMs]);
    return (_jsx(Background, { "$roundedCorners": roundedCorners, children: _jsxs(InfoBox, { children: [_jsx(SvgIcon, { name: "streamrTvLogo" }), _jsxs("div", { children: [!liveIn && _jsx(LiveIn, { children: "No broadcast at the moment" }), liveIn !== null && startDate !== null && (_jsxs("div", { children: [_jsxs(LiveIn, { children: ["Live in ", liveIn] }), _jsxs(DateContainer, { children: [formatDate(startDate, 'd LLLL'), " at", ' ', formatDate(startDate, 'h:mmaaa')] })] }))] })] }) }));
}
const Background = styled.div `
    display: block;
    height: 100%;
    width: 100%;

    position: absolute;
    top: 0;
    left: 0;

    // Show the background image
    &::before {
        display: block;
        content: '';
        width: 100%;
        height: 100%;
        background-image: url('prelive.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: ${({ $roundedCorners }) => $roundedCorners ? '1rem' : '0'};
    }
`;
const InfoBox = styled.div `
    position: absolute;
    display: grid;
    grid-template-rows: 1fr auto;
    left: 0;
    bottom: 0;
    margin: 1.5rem;
    padding: 2rem;
    max-width: 20.5rem;
    height: 13.5rem;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(40.2159px);
    border-radius: 0.75rem;
    font-family: "IBM Plex Sans", "Helvetica Neue", Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 1.5rem;
`;
const LiveIn = styled.div `
    letter-spacing: -0.02em;
    color: #FFFFFF;
    opacity: 0.5;
`;
const DateContainer = styled.div `
    letter-spacing: -0.02em;
    color: #FFFFFF;
`;
